<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>
  
<c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
    <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="generateReport()">
        <c-row [gutter]="{gy: 1}">
            <c-col lg="5">
                <c-date-range-picker [startDate]="startDate" [endDate]="endDate" (startDateChange)="onStartDateChane($event)" (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
            </c-col>
            <c-col lg="2">
                <input cFormControl type="text" formControlName="CompanyCIF" placeholder="Enter CIF" />
            </c-col>            
            <c-col md="auto">
                <button cButton type="submit">
                    Generate Report
                </button>
            </c-col>
            <c-col md="auto">
                <button *ngIf="bShowDownloadButton" cButton (click)="downloadReport()">
                    Download Report
                </button>
            </c-col>
        </c-row>
    </form>
</c-container>
</c-navbar>

<c-smart-table id="auditReportTable"
[columnSorter]="true"
[columns]="columns"
[columnFilter]="true"
[itemsPerPageSelect]="true" 
[itemsPerPage]="10" 
[items]="reportData"
[tableBodyProps]="{ align: 'middle' }"
[tableProps]="{ hover: true, striped: true, responsive: true }"
clickableRows
header
pagination>
<ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
    <td>
    <ng-container [ngSwitch]="columnName">
        <ng-container *ngSwitchCase="'createdOn'">
            {{(getDateDisplayString(item.createdOn))}}
        </ng-container>
        <ng-container *ngSwitchCase="'decisionOn'">
            {{(getDateDisplayString(item.decisionOn))}}
        </ng-container>
        <ng-container *ngSwitchCase="'active'">
            {{(getActiveState(item.active))}}
        </ng-container>
        <ng-container *ngSwitchCase="'enable'">
            {{(getEnabledState(item.enable))}}
        </ng-container>
        <ng-container *ngSwitchCase="'isMaker'">
            {{(getMakerState(item.isMaker ))}}
        </ng-container>
        <ng-container *ngSwitchCase="'isCIFLevelAuthority'">
            {{(getCIFAccountState(item.isCIFLevelAuthority))}}
        </ng-container>
        <ng-container *ngSwitchCase="'threshold'">
            {{(getThresholdState(item.threshold))}}
        </ng-container>
        <ng-container *ngSwitchCase="'isDecisionTaken'">
            {{(getDecisionState(item.isDecisionTaken))}}
        </ng-container>
        <ng-container *ngSwitchCase="'isApproved'">
            {{(getApprovalState(item))}}
        </ng-container>
        <ng-container *ngSwitchDefault>
            {{tdContent}}
        </ng-container>
    </ng-container>
    </td>
</ng-template>
</c-smart-table>